import { useState } from "react";
import { func, object, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { AddButton, Alert, Checkbox } from "@components";
import { Tooltip } from "@material-ui/core";

export const SectionCheckbox = observer(({
  section,
  workTypeName,
  onChange,
  onWorkTypeAdd,
}) => {
  const { t } = useTranslation();

  const [ openModal, setOpenModal ] = useState(false);

  const handleWorkTypeAdd = () => {
    setOpenModal(false);
    onWorkTypeAdd();
  }

  return (
    <Checkbox
      key={section.id}
      name={section.name}
      checked={section.newState}
      label={section.name}
      disabled={!section.exists}
      onChange={onChange}
    >
      {
        !section.exists &&
        <>
          <Tooltip
            placement="bottom-start"
            title={<>
              <p>{t("views.editor.dialogs.display.disabled_tooltip.part1", { workTypeName })}</p>
              <br />
              <p>{t("views.editor.dialogs.display.disabled_tooltip.part2", { workTypeName })}</p>
            </>}
          >
            <AddButton
              onClick={() => setOpenModal(true)}
              tabIndex={-1}
              name="Add breakdown work type"
              className="noDrag ml-2"
            />
          </Tooltip>
          <Alert
            title={t("views.editor.dialogs.display.add_to_section", { workTypeName, sectionName: section.name })}
            isOpen={openModal}
            onCancel={() => setOpenModal(false)}
            onAccept={handleWorkTypeAdd}
            acceptText={t("common.yes")}
            cancelText={t("common.no")}
          />
        </>
      }
    </Checkbox>
  );
})

SectionCheckbox.propTypes = {
  section: object.isRequired,
  workTypeName: string.isRequired,
  onChange: func.isRequired,
  onWorkTypeAdd: func.isRequired,
}